import { State } from './State';
import { Action } from './Action';

export class StateLink {
  state: State;
  description: Record<string, any>;
  actions: Action[];

  constructor(state: State, description: Record<string, any>, actions: Action[]) {
    this.state = state;
    this.description = description;
    this.actions = actions;
  }
}
